import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import moment from 'moment/moment';
import { Col, Panel, Row } from 'react-bootstrap';
import DelaySearch from './components/DelaySearch';
import DelayTable from './components/DelayTable';
import DelayLegend from './components/DelayLegend';
import {
    getDelays,
    getDelaySearch,
    getIsDelayFetching,
    loadDelays,
    storeSearchDelays,
    INITIAL_DELAY_SEARCH_FORM,
} from '../duck';
import { getDashboardEvents } from '../../../shared/ducks/events';

class DashboardDelays extends Component {
    componentDidMount() {
        this.props.loadDelays(this.props.search);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dashboardEvents.length !== this.props.dashboardEvents.length) {
            this.fetchData();
        }
    }

    handleChange = e => {
        const searchForm = update(this.props.search, {
            [e.target.name]: { $set: e.target.value },
        });
        this.props.storeSearchDelays(searchForm);
    };

    handleDateChange = name => date => {
        const newSearch = update(this.props.search, {
            [name]: {
                $set: date,
            },
        });
        this.props.storeSearchDelays(newSearch);
    };

    handleSubmit = e => {
        e.preventDefault();
        this.fetchData();
    };

    handleReset = () => {
        this.props.storeSearchDelays(INITIAL_DELAY_SEARCH_FORM);
        this.props.loadDelays(INITIAL_DELAY_SEARCH_FORM);
    };

    prepareFormDataForPost = form => {
        return update(form, {
            abnormalityDate: {
                $set: form.abnormalityDate ? moment(form.abnormalityDate).format('YYYY-MM-DD') : '',
            },
            runDate: {
                $set: form.runDate ? moment(form.runDate).format('YYYY-MM-DD') : '',
            },
        });
    };

    fetchData = () => {
        const preparedForm = this.prepareFormDataForPost(this.props.search);
        this.props.loadDelays(preparedForm);
    };

    render() {
        const { delays, search, isFetching } = this.props;

        return (
            <Row>
                <Col style={{ margin: 20 }}>
                    <Panel collapsible defaultExpanded header="DELAYS">
                        <DelaySearch
                            search={search}
                            isFetching={isFetching}
                            handleChange={this.handleChange}
                            handleDateChange={this.handleDateChange}
                            handleSubmit={this.handleSubmit}
                            handleReset={this.handleReset}
                        />
                        <DelayLegend />
                        <DelayTable data={delays} isFetching={isFetching} />
                    </Panel>
                </Col>
            </Row>
        );
    }
}

export default connect(
    state => ({
        delays: getDelays(state),
        isFetching: getIsDelayFetching(state),
        search: getDelaySearch(state),
        dashboardEvents: getDashboardEvents(state),
    }),
    {
        loadDelays,
        storeSearchDelays,
    }
)(DashboardDelays);
